import request from '@/utils/request'
const apiPath = '/course/courseExamRecords'
import { downloadBlob } from '@/utils/download'
const courseExamRecordsApi = {
  /**
   * 新增【考试记录】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【考试记录】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【考试记录】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【考试记录】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  exportExcel2(query) {
    return request.get(apiPath + '/exportExcel2', { params: query })
  },
  /**
   * 删除单个【考试记录】
   */
}
export default courseExamRecordsApi
